import { sendPost } from '@lokalise/frontend-http-client';
import wretch from 'wretch';
import { z } from 'zod';

import { getCookie } from '../request';

const client = wretch('');

const responseBodySchema = z.object({
    accessToken: z.string(),
});

/**
 * Fetches service JWT for the given project.
 * @param projectId
 * @return JWT token
 */
const fetchServiceJwt = async (projectId: string): Promise<string> => {
    const responseBody = await sendPost(
        client.headers({
            'content-type': 'application/json',
            'X-CSRF-Token': getCookie('csrf_token') || '',
        }),
        {
            path: `/projects/${projectId}/actions/get-user-token`,
            responseBodySchema,
        },
    );

    return responseBody.accessToken;
};

export default fetchServiceJwt;
